import GreenRedButtonBlock from './green-red-button-block';

export default GreenRedButtonBlock;
